import React from "react";
import News, { NewsData } from "./News";

const NewsPlural: React.FC<{
  newsPlural: NewsData[];
}> = ({ newsPlural }) => {
  return newsPlural.length > 0 ? (
    <div className="newsPlural">
      {newsPlural.map((news) => (
        <News key={news.id} news={news} />
      ))}
    </div>
  ) : null;
};

export default NewsPlural;
